<template>
    <text-loading-placeholder v-if="isLoading" />
    <div
            v-else
            :title="castNestedValue(content)"
    >
        {{ castNestedValue(content) }}
    </div>
</template>

<script>
    import {AppResource} from  "@sellers-shield-home-protection/ss-core-js";
    import TableCellsMixin from "../../Mixins/TableCellsMixin";

    export default {
        name: 'Cell',

        mixins: [TableCellsMixin],

        props: {
            content: {
                type: String,
                default: '---',
            },
            appResource: {
                type: AppResource,
                required: false,
            },
            getCurrentValue: {
                type: Function
            },
            isLoading: {
                type: Boolean,
                default: false,
                required: false,
            },
        },
        methods: {
            castNestedValue(content) {
                let value = '---';
                if (typeof this.getCurrentValue === 'function') {
                    value = this.getCurrentValue(this.appResource);
                    return value;
                }
                value = this.getNestedValue(content);
                return value;
            }
        }
    };
</script>
